import { render, staticRenderFns } from "./surgaltiinBaiguullaga.vue?vue&type=template&id=b8de427c&"
import script from "./surgaltiinBaiguullaga.vue?vue&type=script&lang=js&"
export * from "./surgaltiinBaiguullaga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports